import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { IProductionVersionDetailLayout } from '../../../../models/layout/production-version-detail-layout.model';
import { IRecipeArticle } from '../../../../models/recipe-article.model';
import { ISharedDataState } from '../../../../services/facades/master-data/shared-data-state.model';
import { SharedDataFacade } from '../../../../services/facades/master-data/shared-data.facade';
import { ProductionVersionLayoutService } from '../../../../services/layout/production-version-layout.service';

@Component({
    selector: 'app-recipe-table',
    templateUrl: './recipe-table.component.html',
    styleUrls: [ './recipe-table.component.scss' ],
})
export class RecipeTableComponent implements OnInit {

    @Input()
    public set recipeArticles(recipeArticles: IRecipeArticle[]) {
        this.datasource.data = recipeArticles;
    }

    @Output()
    public onArticleSelected: EventEmitter<number> = new EventEmitter();

    public sharedDataState$: Observable<ISharedDataState>;
    public layout: IProductionVersionDetailLayout;

    public datasource: MatTableDataSource<IRecipeArticle> = new MatTableDataSource<IRecipeArticle>([]);

    constructor(private myProductionVersionLayoutService: ProductionVersionLayoutService,
                private mySharedDataFacade: SharedDataFacade) {
    }

    public ngOnInit(): void {
        this.sharedDataState$ = this.mySharedDataFacade.subState();
        this.layout = this.myProductionVersionLayoutService.getProductionVersionDetailLayout();
    }

    public selectArticle(productionVersionId: number): void {
        this.onArticleSelected.emit(productionVersionId);
    }

}
